// Lightweight "recently visited routes" tracker backed by localStorage.
//
// Layout records the current pathname on every navigation; the Welcome
// launchpad reads the list to power its "Jump back in" strip. Deliberately
// tiny — no analytics, no server round-trip.

const STORAGE_KEY = 'recent_routes';
const MAX_ENTRIES = 8;

// Routes we never want to surface as a "recent" shortcut: the launchpad itself,
// auth/utility pages, and deep detail routes are noise for a quick-jump list.
const IGNORED_EXACT = new Set(['/welcome', '/login', '/403', '/change-password', '/my-account']);

const isIgnored = (path) => {
  if (!path || IGNORED_EXACT.has(path)) return true;
  // Skip "new" / create sub-routes — the launchpad's quick actions already
  // cover those, and they aren't useful as a "jump back in" destination.
  if (path.endsWith('/new') || path.includes('/new/')) return true;
  return false;
};

const read = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

// Push a path to the front of the recents list (most-recent-first), de-duped.
export const recordRecentRoute = (path) => {
  if (isIgnored(path)) return;
  try {
    const next = [path, ...read().filter((p) => p !== path)].slice(0, MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable (private mode, quota) — recents are best-effort.
  }
};

// Read the recents list, most-recent-first.
export const getRecentRoutes = () => read();
